import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import MaintenanceService from '../services/MaintenanceService';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dropdown } from 'primereact/dropdown';
import TypeMaintenanceService from '../services/TypeMaintenanceService';
import VehiculeService from '../services/VehiculeService';
import PieceRechangeService from '../services/PieceRechangeService';
import ContratService from '../services/ContratService';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';

const Maintenance = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Table {...{setForm, setYesNo}} />
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setForm, setYesNo} = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        MaintenanceService.get((data, status) => {
                //console.log(data[0].piecesRechanges[0]);
                setLoading(false);
                if(status) setItems(data);   
            },
            {size: itemPerPage}
        );
    }

    

    const openNew = () => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: null,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        });
    }

    const editItem = (item) => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: item,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        })
    }

    const deleteItem = (item) => {
        setYesNo({   
            visible: true,
            message : "Confirmez-vous la suppression ?",
            hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
            callback : ()=> {
                setLoading(true);
                MaintenanceService.delete(item.id, (data, status)=>{
                    setLoading(false);
                    loadItems();
                });
            },
        });
    }
    
    return (
        <>
            <h5>Liste des maintenances</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" 
                                onClick={openNew}/>
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={rows} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}  */
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="dateMaintenance" header="Date maintenance" sortable 
                    body={(item)=> new Date(item.dateMaintenance).toLocaleDateString()}/>
                <Column field="maintenanceEntretien" header="Maintenance entretien" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.maintenanceEntretien === false ? 'proposal' : 'qualified'}`}>
                        {item.maintenanceEntretien === false ? "NON" : "OUI"}
                    </span>
                } />
                <Column field="maintenanceReparation" header="Maintenance réparation" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.maintenanceReparation === false ? 'proposal' : 'qualified'}`}>
                        {item.maintenanceReparation === false ? "NON" : "OUI"}
                    </span>
                } />
                <Column field="montant" header="Montant" sortable body={item => item.montant?.toLocaleString()} />
                <Column field="numeroMaintenance" header="Numéro maintenance" sortable />
                <Column field="observation" header="Observation" sortable />
                {/* <Column field="piecesRechanges[0]" header="Pièces rechanges" sortable 
                    body= {(item) => item.piecesRechanges[0].libellePiece} /> */}
                <Column field="typeMaintenance.libelleTypeMaintenance" header="Libellé type Maintenance" sortable />
                <Column field="vehicule.immatriculation" header="Véhicule" sortable />
                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editItem(selectedItem)}/>
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" onClick={()=> deleteItem(selectedItem)}/>
                    </div>
                } />
            </DataTable>
        </>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);

    const [typeMaintenances, setTypeMaintenances] = useState([]);
    const [vehicules, setVehicules] = useState([]);
    const [piecesRechange, setPiecesRechange] = useState([]);
    const [contrats, setContrats] = useState([]);

    useEffect(()=> {
        if(!visible) return;
        TypeMaintenanceService.get((data)=> data && setTypeMaintenances(data), {size: pageMaxSize})
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        VehiculeService.get((data)=> data && setVehicules(data), {size: pageMaxSize})
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        PieceRechangeService.get((data)=> data && setPiecesRechange(data), {size: pageMaxSize})
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        ContratService.get((data)=> data && setContrats(data), {size: pageMaxSize})
    }, [visible]);
    
    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, [e.target.id]: value});
        }
        else if(e.checked !== undefined) {
            setData({...data, [e.target.id]: e.target.checked});
        }else{
            alert("Binding fails.")
        }
    }
    
    const submit = () => {
        setYesNo(
            {   
                visible: true,
                message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(data.id) MaintenanceService.update(data, onResponse); else MaintenanceService.add(data, onResponse);
                },
            }
        )
    
    }

    const choice = [
        {label: "OUI", value: true},
        {label: "NON", value: false}
    ]

    return(
        <Dialog visible={visible} style={{ width: '800px' }} header="Détails d'une maintenance" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Valider" icon="pi pi-check" className="p-button-text" onClick={submit} loading={loading} />
                </>
            } 
            onHide={hide}
            >  
                <div className="field" hidden>
                    <label htmlFor="id">Identifiant</label>
                    <InputText id="id" value={data && data.id} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="maintenanceEntretien">Maintenance entretien</label>
                    <Dropdown id="maintenanceEntretien" options={choice}
                        value={data && data.maintenanceEntretien} onChange={bind} 
                        placeholder="Aucune sélection" />
                </div> 
                {data?.maintenanceEntretien === true ? (null) : (
                    <div className="field">
                        <label htmlFor="maintenanceReparation">Maintenance réparation</label>
                        <Dropdown id="maintenanceReparation" options={choice}
                            value={data && data.maintenanceReparation} onChange={bind}
                            placeholder="Aucune sélection" />
                    </div>
                )}
                 
                <div className="field">
                    <label htmlFor="dateMaintenance">Date maintenance</label>
                    <InputText type="date" id="dateMaintenance" value={data && data.dateMaintenance} onChange={bind}/>
                </div>
                <div className="field">
                    <label htmlFor="montant">Montant</label>
                    <InputNumber id="montant" value={data && data.montant} onValueChange={bind} required keyfilter="num" />
                </div>
                <div className="field">
                    <label htmlFor="numeroMaintenance">Numéro maintenance</label>
                    <InputText id="numeroMaintenance" value={data && data.numeroMaintenance} onChange={bind} 
                        placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="typeMaintenance">Type Maintenance</label>
                    <Dropdown id="typeMaintenance" options={typeMaintenances} value={data?.typeMaintenance} onChange={bind}
                        optionLabel="libelleTypeMaintenance" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="vehicule">Matériel roulant</label>
                    <Dropdown id="vehicule" options={vehicules} value={data?.vehicule} onChange={bind}
                        optionLabel="immatriculation" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="piecesRechanges">Pièces Rechanges</label>
                    <MultiSelect id="piecesRechanges" options={piecesRechange} value={data?.piecesRechanges} onChange={bind}
                        optionLabel="libellePiece" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="contrat">Contrat</label>
                    <Dropdown id="contrat" options={contrats} value={data?.contrat} onChange={bind}
                        optionLabel="referenceContrat" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="observation">Observation</label>
                    <InputText id="observation" value={data && data.observation} onChange={bind} placeholder="" />
                </div>
            </Dialog>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default Maintenance;